// [S-411 / E-MULTI-TENANT] The signed-in user's tenant memberships, for the
// tenant switcher. Backed by the authed GET /me/memberships endpoint.
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "./api";
import { useAuth } from "../auth/AuthProvider";
import type { WebMembership } from "../auth/activeTenantContext";

export function useMyMemberships(): UseQueryResult<WebMembership[], Error> {
  const api = useApi("admin");
  const { state } = useAuth();
  const uid = state.status === "authenticated" ? state.session.uid : null;
  return useQuery({
    // Key on uid (not the active tenant) — the membership SET is per identity
    // and must not refetch on every switch.
    queryKey: ["memberships", uid],
    enabled: uid !== null,
    queryFn: async () => {
      const res = await api<{ memberships: WebMembership[] }>("/me/memberships");
      return res.memberships;
    },
  });
}
